import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import addDesign from '../actions/addDesign';
import NewEstimateButton from './NewEstimateButton';
import { create } from '../helpers/validationFunctionFactory';
import controlNewDesignModal from '../actions/uiState/controlNewDesignModal';

const mapStateToProps = ({ estimateBuilder }) => {
  const { estimates } = estimateBuilder.entities;
  const { newDesignModalOpen } = estimateBuilder.uiState;
  const nameList = estimates.allIds.map(givenId => estimates.byId[givenId].name);

  const validateFunction = create(nameList, 50, 'Design name');

  return {
    validate: validateFunction,
    defaultName: `Design ${estimates.allIds.length + 1}`,
    newDesignModalOpen,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ addDesign, controlNewDesignModal }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewEstimateButton);
